import { MembershipEmailDomainUser } from 'src/v2/commons/interface/membershipEmailDomain'
import { rootApi } from 'src/v2/store/api/rootApi'

import {
  IAddEmailDomainToUser,
  ICreateEmailDomain,
  IEmailDomain,
} from '../emailDomain.types'

export const emailDomainApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getEmailDomains: builder.query<IEmailDomain[], void>({
      query: () => ({
        url: '/email-domains',
        method: 'GET',
      }),
      providesTags: ['EMAIL_DOMAINS'],
    }),
    getMembershipEmailDomain: builder.query<
      { signatureTemplate: string },
      { id: string }
    >({
      query: (data) => ({
        url: `/membership-domain/${data.id}`,
        method: 'GET',
      }),
      providesTags: ['MEMBERSHIP_DOMAIN'],
    }),
    getMembershipEmailDomains: builder.query<
      MembershipEmailDomainUser[],
      string
    >({
      query: (membershipId) => ({
        url: `/v2/membership-domain/membership/${membershipId}`,
        method: 'GET',
      }),
      providesTags: (_result, _error, membershipId) => [
        { type: 'MEMBERSHIP_DOMAIN', id: membershipId },
      ],
    }),
    createEmailDomain: builder.mutation<null, ICreateEmailDomain>({
      query: (data) => {
        const { domain, isWBFRegister } = data
        return {
          url: '/email-domains',
          method: 'POST',
          data: {
            domain,
            isWBFRegister,
          },
        }
      },
      invalidatesTags: ['EMAIL_DOMAINS'],
    }),
    addEmailDomainToUser: builder.mutation<null, IAddEmailDomainToUser>({
      query: (data) => {
        const { type, membershipId, name, emailDomainId, signatureTemplate } =
          data
        return {
          url: '/membership-domain',
          method: 'POST',
          data: {
            type,
            membershipId,
            name,
            emailDomainId,
            signatureTemplate,
          },
        }
      },
      invalidatesTags: ['GET_USER'],
    }),
    updateEmailDomainUser: builder.mutation<
      null,
      { id: string } & IAddEmailDomainToUser
    >({
      query: (data) => {
        const {
          id,
          type,
          membershipId,
          name,
          emailDomainId,
          signatureTemplate,
        } = data
        return {
          url: `/membership-domain/${id}`,
          method: 'PATCH',
          data: {
            type,
            membershipId,
            name,
            emailDomainId,
            signatureTemplate,
          },
        }
      },
      invalidatesTags: ['GET_USER', 'MEMBERSHIP_DOMAIN'],
    }),
    removeEmailDomainFromUser: builder.mutation<null, { id: string }>({
      query: (data) => {
        const { id } = data
        return {
          url: `/membership-domain/${id}`,
          method: 'DELETE',
        }
      },
      invalidatesTags: ['GET_USER'],
    }),
  }),
})

export const {
  useGetEmailDomainsQuery,
  useGetMembershipEmailDomainQuery,
  useGetMembershipEmailDomainsQuery,
  useCreateEmailDomainMutation,
  useAddEmailDomainToUserMutation,
  useUpdateEmailDomainUserMutation,
  useRemoveEmailDomainFromUserMutation,
} = emailDomainApi
